import { render, staticRenderFns } from "./HomeMasterKong.vue?vue&type=template&id=cd40758c&scoped=true&"
import script from "./HomeMasterKong.vue?vue&type=script&lang=js&"
export * from "./HomeMasterKong.vue?vue&type=script&lang=js&"
import style0 from "./HomeMasterKong.vue?vue&type=style&index=0&id=cd40758c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd40758c",
  null
  
)

export default component.exports